// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__37Sbc","messages":"Chat_messages__qIOFm","dateDivider":"Chat_dateDivider__2Tlb9"};